<svg
  width="16"
  height="14"
  viewBox="0 0 16 14"
  fill="none"
  class={$$restProps.class}
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M10.8982 14V11.485H7.54491V3.1018H4.77844V5.61677H0V0H4.77844V2.51497H10.8982V0H15.6766V5.61677H10.8982V3.1018H8.13174V10.8982H10.8982V8.38323H15.6766V14H10.8982ZM11.485 5.02994H15.0898V0.586826H11.485V5.02994ZM11.485 13.4132H15.0898V8.97006H11.485V13.4132ZM0.586826 5.02994H4.19162V0.586826H0.586826V5.02994Z"
    fill="#1C1C20"
  />
</svg>
